import { SITE, ABOUT_IMAGE } from "../data/site";
import useReveal from "../hooks/useReveal";

export default function About() {
  const ref = useReveal();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 sm:py-36 lg:py-44 grain"
    >
      <div ref={ref} className="reveal max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image side */}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={ABOUT_IMAGE}
                alt="Isaiah Artavia headshot"
                className="w-full h-full object-cover"
                data-testid="about-portrait"
              />
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "linear-gradient(180deg, transparent 60%, rgba(10,10,12,0.55) 100%)",
                }}
              />
            </div>
            <div className="absolute -bottom-6 -left-6 h-24 w-24 border-l border-b border-[#991B1B]/60" />
            <div className="absolute -top-6 -right-6 h-24 w-24 border-t border-r border-[#D4AF37]/30" />
          </div>

          {/* Text side */}
          <div className="lg:col-span-7">
            <div className="overline text-[#991B1B] mb-6" data-testid="about-overline">
              — About
            </div>
            <h2
              data-testid="about-title"
              className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] text-white tracking-tight"
            >
              A performer<br />
              <span className="italic text-[#A0A0A8]">at home in the dark.</span>
            </h2>

            <div className="mt-10 space-y-6 text-[#A0A0A8] text-base sm:text-lg leading-relaxed max-w-2xl">
              {SITE.bio.map((p, i) => (
                <p key={i} data-testid={`about-paragraph-${i}`}>
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-6 max-w-2xl">
              <div>
                <div className="overline mb-2">Based</div>
                <div className="text-white text-sm">{SITE.contact.location}</div>
              </div>
              <div>
                <div className="overline mb-2">Discipline</div>
                <div className="text-white text-sm">Theatre · Film · TV</div>
              </div>
              <div>
                <div className="overline mb-2">Status</div>
                <div className="text-white text-sm">Seeking Representation</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
